import { render, staticRenderFns } from "./TreeviewPage.vue?vue&type=template&id=8a8d532c&"
import script from "./TreeviewPage.vue?vue&type=script&lang=js&"
export * from "./TreeviewPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports